module.exports = __webpack_public_path__ + "media/src/assets/images/amenities_blue/parking_lot-e62b2cb8c4e07b5d461e72302a6bf710.svg";